























import Vue from 'vue'
import moment from 'moment/moment'
import request from '@/utils/request'
import config from '@/utils/config'
import changeUnit from '@/utils/changeUnit'
export default Vue.extend({
    props: {
        menuItem: {
            type: Object,
        },
        recommendData: {
            type: Array,
        },
    },
    watch: {
        menuItem() {
            // console.log(this.menuItem)
            // this.getClassifyArr()
            // this.itemIdArr = []
            // this.pageNum = 1
            // this.pageSize = 6
        },
    },
    data() {
        return {
            imgUrl: config.imgUrl,
            barId: '',
        }
    },
    created() {
        // this.getClassifyArr()
    },
    methods: {
        // getClassifyArr() {},
        checkDetail(detailId: any) {
            this.$router.push({
                path: '/detailsPage',
                query: {
                    barId: this.menuItem.id,
                    detailId,
                },
            })
        },
    },
    filters: {
        getChangeUnit(value: any) {
            return changeUnit.changeUnit(value)
        },
    },
})
